import React from 'react';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { employeesService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import { getFirstLastInterval } from "utils/datetime";
import * as shiftsActions from 'actions/shiftsActions';

class EmployeeRestrictedShiftEdit extends React.Component {
  constructor(props) {
    super(props);

    // console.log(props);

    // NOTA: En este caso no hay edit

    this.state = {
      isLoading: false,
      submitted: false,
      errors: {},
      shift_id: -1,
    };
  }


  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  checkValidField = (name) => {
    return (this.state.submitted && this.state.errors[name] !== undefined && this.state.errors[name] !== '');
  }

  handleSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    const props = this.props;

    const response = await employeesService.addRestrictedShiftEmployee(props.employee.id, this.state.shift_id);

    if (response.ok) {
      this.setState({
        isLoading: false,
        errors: {},
      }, () => {

        toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
        props.getRestrictedShifts();
        if (typeof props.onDataChanged === "function") {
          props.onDataChanged();
        }
        props.handleClose();

      });
    }
    else {
      this.setState({
        isLoading: false,
        submitted: true,
        errors: errorFormating(response)
      });
    }
  }

  render() {
    const { select_shifts } = this.props;
    const { shift_id } = this.state;


    const optionList = select_shifts.length > 0 && select_shifts.map((item, i) => {
      return (
        <option key={i} value={item.id}>{item.name} {getFirstLastInterval(item.time_intervals, true)}</option>
      )
    }, this);

    return (

      <form onSubmit={this.handleSubmit}>
        <div className="modal-body">
          <FormGroup className="form-group" controlId="shift_id">
            <FormLabel>{this.props.t('common.shift')}</FormLabel>
            <FormControl
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              value={shift_id}
              isInvalid={this.checkValidField('shift_id')}
              as="select">
              <option value="-1">{this.props.t('common.selectShift')}</option>
              {optionList}
            </FormControl>

            <FormControl.Feedback type="invalid">
              {this.state.errors.shift_id}
            </FormControl.Feedback>
          </FormGroup>

          {this.state.errors && this.state.errors.general && (
            <div
              className="alert alert-danger alert-general-error fade show"
              role="alert"
            >
              {this.state.errors.general}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button type="button" onClick={this.props.handleClose} className="btn btn-outline-primary">{this.props.t('common.cancel')}</button>
          <SubmitButton
            type="submit"
            isLoading={this.state.isLoading}
            text={this.props.t('common.save')}
            loadingText={this.props.t('common.saving')}
          />
        </div>
      </form>
    )
  }
}

const mapStateToProps = (state, myProps) => {
  return {
    ...state.shiftsReducer,
    employee: myProps.employee,
  }
};

export default connect(mapStateToProps, shiftsActions)(withTranslation()(EmployeeRestrictedShiftEdit));